import React, { useState } from "react";
import { connect } from "react-redux";
import { useRouter } from 'next/router'
import { useDispatch } from "react-redux";
import { saveCurrentBot } from "../../../redux/products/actions";
import axios from "axios";
import endpoints from "../../../utility/endpoints";
import styles from "../../../styles/pages/botStore.module.scss";
import { imageBaseURL } from "../../../data/createBotForm";
import Addproduct from './Addproduct'

function index(props) {

    const [auth, setAuth] = useState({});
    const [editProduct, setEditProduct] = useState(false);
    const [editData, setEditData] = useState({});
    const router = useRouter()
    const goToPage1 = (link) => {
        router.push('/product');
      };
    const [currentBot, setCurrentBot] = React.useState([])
  const [loading, setLoading] = React.useState(false);
    const dispatch = useDispatch()
    React.useEffect(() => {
        //console.log(props.currentBot,"====>cuurender")
        setCurrentBot(props.currentBot)
        if(props.currentBot[0]){
            let editData = {
                product_id: window.atob(router.query.prodId),
                mco:'',
                clusters_live: props.currentBot[0]?.clusters_live,
                subarea: props.currentBot[0]?.subarea,
                lead_platform: props.currentBot[0].lead[0]?.lead_platform,
                lead: props.currentBot[0]?.leads,
                catalog_products: props.currentBot[0]?.catalog_products,
                product_status: props.currentBot[0]?.product_status,
                product_title: props.currentBot[0]?.product_title,
                product_caption: props.currentBot[0]?.product_caption,
                hrs_saved: props.currentBot[0]?.hrs_saved,
                hrs_saved_text: props.currentBot[0]?.hrs_saved_text,
                benefits:props.currentBot[0]?.benefits_array,
                process:props.currentBot[0]?.process_array,
                product_banner:props.currentBot[0]?.product_banner,
                product_video:props.currentBot[0]?.product_video,
                product_description:props.currentBot[0]?.product_description,
                isDocument:props.currentBot[0]?.isDocument,
                document_url:props.currentBot[0]?.document_url,
                area: props.currentBot[0]?.area
            }
            setEditData(editData);
        }
    }, [props.currentBot])
    const fetchProd = async (auth) => {
        if (router.query.prodId) {
            let authCheck = await JSON.parse(localStorage.getItem("auth")).data;

            let expiryStatus = await props.checkExpiry(authCheck);
            if (expiryStatus) {
                axios({
                    method: "post",
                    url: `${endpoints.baseUrl}/task/getProducts`,
             	    data:{
                        "product_id": window.atob(router.query.prodId),
                        "cluster":"",
                        "clusters_live":"",
                        "catalog_products":"",
                        "product_title": "",
                        "sub_area":"",


                    },
                    headers: {
                        Authorization: `${auth.accessToken}|${auth.email}`,
                    },
                }).then((res) => {
                    if (res.data.code == 200) {
                          //console.log(res.data.data, "data bot from response");
                        if (
                            res.data.data
                        ) {
                            dispatch(saveCurrentBot(res.data.data));
                        }
                    }
                })
            }
        }
    }


        React.useEffect(async () => {
            let authCheck = _.get(JSON.parse(localStorage.getItem("auth")), "data", "");

            let expiryStatus = await props.checkExpiry(authCheck);

            if (expiryStatus) {
                let auth = JSON.parse(localStorage.getItem("auth")).data;
                fetchProd(auth);
                setAuth(auth)
            } else {
                setLoading(false);
                props.sessionTimeOutCheck(true);
            }

            if (router.query.searchResults) {
                setSearchResults(true);
            }
        }, [router.query]);


        React.useEffect(() => {
            //console.log(router.query, "all kinda queries")
        }, [router.query])

        const deleteProduct = async () => {

            let auth = JSON.parse(localStorage.getItem("auth")).data;
            
            try {
                
              const productResponse = await axios({
                method: "POST",
                url: `${endpoints.baseUrl}${'/task/deleteProduct'}`,
                headers: {
                  Authorization: `${auth.accessToken}|${auth.email}`,
                },
                data: 
                {
                    "product_id": window.atob(router.query.prodId),
                }
              });
              goToPage1();
            } catch (e) {
              console.log("failed to delete Product "+e);
            }
          };

        return (
            <>
            {!editProduct ? <>{
            loading? (
                <div style={{ height: "800px" }}>
                  <Loader />
                </div>
            ): currentBot.length>0 && ( 
              <div>
            <div className="container h-100">
            <ul class={styles.breadcrumb}>
                <li><a href={()=>void(0)} onClick={()=>goToPage1()} >Product Page</a></li>
                <li><a href={()=>void(0)} >{currentBot[0]?.catalog_products}</a></li>
                <li>{currentBot[0]?.product_title}</li>
            </ul>
                <div className="row  mt-5 pt-5">
                    <div className="col-md-6 col-12">
                        <div className={styles.crard_main_section}>
                            <div className="d-flex align-items-center mb-2 pb-1">
                                <img src={`${imageBaseURL + currentBot[0]?.product_banner}`} alt="" className="mr-2" /><h1 style={{ fontWeight: "600" }}>{currentBot[0]?.product_title}</h1>
                            </div>
                            <div className={styles.card_section1}>
                                <div className="mb-2">
                                    <img src={`${imageBaseURL}maps.svg`} alt="" className="mr-2" />
                                    <span>{currentBot[0]?.lead[0].lead_platform}</span>
                                </div>
                                <p>{
                                    currentBot[0]?.leads.length>0 && currentBot[0]?.leads.map((va)=>{
                                    return va.country && va.country != ""  ?  `${va.cluster} (${va.country}) ` : `${va.cluster}`
                                    })
                                    }
                                    {/* North America(USA) ,LATAM ( Costa Rica, Honduras, Guatemala, Nicaragua, El salvadour ), NAMETRUB (Turkey) */}
                                    </p>
                            </div>
                            <p className="crard_main_section_p">{currentBot[0]?.product_caption}</p>
                        </div>
                        <div className={styles.blue_card_section}>
                            <div className="d-flex align-items-center justify-content-center">
                                <div className="d-flex  mr-4" >
                                    <h1 className="align-self-center mr-4">{currentBot[0]?.hrs_saved}</h1>
                                    <p className="align-self-center">{currentBot[0]?.hrs_saved_text}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-12 align-self-end">
                        <div className={styles.iframe_section} dangerouslySetInnerHTML={{ __html: `<iframe src="${currentBot[0]?.product_video?.includes("https://www.youtube.com/watch?v=") ? (currentBot[0]?.product_video)?.replace('https://www.youtube.com/watch?v=','https://www.youtube.com/embed/') : currentBot[0]?.product_video?.includes("https://drive.google.com") ? (currentBot[0]?.product_video)?.replace('view','preview') : currentBot[0]?.product_video}" paused/>` }} ></div>
                    </div>
                </div>
                <div className="row" style={{marginTop:"10px",marginBottom:"15px"}}>

                    <div className="col-md-8">
                        {currentBot[0]?.isDocument && currentBot[0]?.document_url && currentBot[0]?.document_url !="" && <a href={currentBot[0]?.document_url} target="blank">Document URL</a>}
                    </div>
                    {
                        auth.userType === "admin" &&
                         <><div className="col-md-2" style={{ paddingLeft: "50px" }}>
                                                <span
                                                    style={{ minWidth: "123px", height: "39px", padding: "8px 16px", border: "0.4px solid #000000", borderRadius: "4px", fontSize: "15px", fontWeight: 400, color: "#000000", cursor: "pointer" }}
                                                    onClick={() => setEditProduct(true)}
                                                >
                                                    Edit Product
                                                </span>
                                            </div><div className="col-md-2" style={{ paddingLeft: "30px" }}>
                                                    <span
                                                        style={{ minWidth: "123px", height: "39px", padding: "8px 16px", border: "0.4px solid red", borderRadius: "4px", fontSize: "15px", fontWeight: 400, color: "red", cursor: "pointer" }}
                                                        onClick={() => deleteProduct(true)}
                                                    >
                                                        Delete Product
                                                    </span>
                                                </div></>
                    }
                </div>
            </div>
            <div className={styles.benefits_section}>
                <div className="container h-100">
                   {currentBot[0]?.benefits_array.length>0 && <div className={styles.Frist_section}>
                    <div className="mb-5">
                <h1>Top Benefits</h1> 
                    </div>
                        <div className="row ">
                            {currentBot[0]?.benefits_array.length>0 && currentBot[0]?.benefits_array.map((va)=>{
                           return( <div className="col-md-3 col-6  mb-4 mb-md-0">
                                <div className={styles.cards_benefits} style={{marginBottom:"15px"}}>
                                    <img src={`${imageBaseURL + va.benefit_icon}`} alt="" />
                                    <p>{va.benefit}</p>
                                </div>
                            </div>)
                            })}
                        </div>
                    </div>}
                   {currentBot[0]?.process_array.length >0 && <div className="row">
                        <div className="col-md-6 ">
                            <div className={`text-center position-relative bot_section ${styles.cards_benefits_card}`}>
                                <img src={`${imageBaseURL}robo.png`} alt="" />
                                <div className="back_image">
                                    <img src={`${imageBaseURL}dot.svg`} className={styles.img_1} alt="" />
                                    <img src={`${imageBaseURL}dot1.svg`} className={styles.img_2} alt="" />
                                    <img src={`${imageBaseURL}dot2.svg`} className={styles.img_3} alt="" />

                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                        <h2 className="" style={{fontWeight:"600"}}>{currentBot[0]?.process_caption}</h2>
                        {currentBot[0]?.process_tex!=="" && <p className="mb-4">{currentBot[0]?.process_text}</p>}
                            {/* <p className="mb-4">1,000s of invoices left to be updated! Don’t worry, we can help your team colate & update invoices on your behalf.</p> */}
                            <ol>
                                {currentBot[0]?.process_array.length>0 && currentBot[0]?.process_array.map((va)=>{
                               return (<li >
                                     <div>
                                       {va.process_head!=="" &&  <h3 style={{color:'#1F36C7'}} >
                                            Detection Systems
                                        </h3>}
                                         <p style={{marginBottom:"0px"}}>{va.process_text}</p>
                                     </div>
                                 </li>)
                                })}
                            </ol>
                        </div>
                    </div>}
                </div>
            </div>
             </div>
            )
            }</>
                : <Addproduct setAddProduct={setEditProduct} data={editData} onSuccess={()=>{setEditProduct(false);location.reload()}} isAdd={false} />
            }
            </>
        );
    }

    const mapStateToProps = (state) => {
        return {
            currentBot: state.storeProduct.currentProducts,
        };
    };

    export default connect(mapStateToProps, null)(index)


